import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosClient from "../../axios-client";

export const fetchCustomersReport = createAsyncThunk(
  "report/fetchCustomersReport",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(
        `message/fetchCustomersByMonthAndUser`,
        {
          params,
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch data"
      );
    }
  }
);
export const fetchOneDayReport = createAsyncThunk(
  "report/fetchOneDayReport",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(
        `message/getApprovedMessagesCountLast24Hours`,
        {
          params,
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch data"
      );
    }
  }
);

export const fetchEvents150Report = createAsyncThunk(
  "report/fetchEvents150Report",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(`message/eventWithGuest`, {
        params,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch data"
      );
    }
  }
);

const initialState = {
  selectedListing: null,
  totalGottonCustomers: 0,
  allReport: [],
  loading: false,
  error: null,
  fromMonth: null,
  toMonth: null,
  gottonSearchText: "",
  gottonCurrentPage: 1,
  oneDayTotal: 0,
  oneDayReport: [],
  oneDayLoading: false,
  oneDayError: null,
  oneDaySearchText: "",
  oneDayCurrentPage: 1,
  events150: [],
  events150Loading: false,
  events150Error: null,
  events150SearchText: "",
  s_GuestCount: 150,
  events150CurrentPage: 1,
};
const allReportSlice = createSlice({
  name: "AllReport",
  initialState,
  reducers: {
    setSelectedListing(state, action) {
      state.selectedListing = action.payload;
    },
    setFromMonth(state, action) {
      state.fromMonth = action.payload;
    },
    setToMonth(state, action) {
      state.toMonth = action.payload;
    },
    setGottonSearchText(state, action) {
      state.gottonSearchText = action.payload;
    },
    setGottonCurrentPage(state, action) {
      state.gottonCurrentPage = action.payload;
    },
    setOneDaySearchText(state, action) {
      state.oneDaySearchText = action.payload;
    },
    setOneDayCurrentPage(state, action) {
      state.oneDayCurrentPage = action.payload;
    },
    setEvents150SearchText(state, action) {
      state.events150SearchText = action.payload;
    },
    setEvents150CurrentPage(state, action) {
      state.events150CurrentPage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomersReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomersReport.fulfilled, (state, action) => {
        state.loading = false;
        state.allReport = action.payload.data;
        state.totalGottonCustomers = action.payload.total;
      })
      .addCase(fetchCustomersReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    builder
      .addCase(fetchOneDayReport.pending, (state) => {
        state.oneDayLoading = true;
        state.oneDayError = null;
      })
      .addCase(fetchOneDayReport.fulfilled, (state, action) => {
        state.oneDayLoading = false;
        state.oneDayReport = action.payload.data;
        state.oneDayTotal = action.payload.totalCount;
      })
      .addCase(fetchOneDayReport.rejected, (state, action) => {
        state.oneDayLoading = false;
        state.oneDayError = action.payload;
      });
    builder
      .addCase(fetchEvents150Report.pending, (state) => {
        state.events150Loading = true;
        state.events150Error = null;
      })
      .addCase(fetchEvents150Report.fulfilled, (state, action) => {
        state.events150Loading = false;
        state.events150 = action.payload.data;
        // state.events150Total = action.payload.totalCount;
      })
      .addCase(fetchEvents150Report.rejected, (state, action) => {
        state.events150Loading = false;
        state.events150Error = action.payload;
      });
  },
});

export const {
  setSelectedListing,
  setFromMonth,
  setToMonth,
  setGottonSearchText,
  setGottonCurrentPage,
  setOneDaySearchText,
  setOneDayCurrentPage,
  setEvents150SearchText,
  setEvents150CurrentPage,
} = allReportSlice.actions;

export default allReportSlice.reducer;
